module.exports = __webpack_public_path__ + "img/img13.9546ce9e.svg";